// removed by extract-text-webpack-plugin
module.exports = {"upload-block":"upload-block","ant-row":"ant-row","upload-file-name":"upload-file-name"};


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/research/pgs/statistics/index.scss
// module id = 1445
// module chunks = 0